import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppIcon, ConfirmModal } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { startFreshRun } from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.slice';

import { Button } from '@mui/material';

const STRINGS = appStrings.modules.satActBooster.results.replan;

/**
 * The calendar's "Replan" CTA: a destructive confirm before a retake wipes the run and sends
 * the student back to the start of the wizard.
 */
export const ReplanControl = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const close = () => setConfirmOpen(false);

  const handleRetake = () => {
    // Finishing the new run creates a submission that supersedes the old one as most-recent.
    dispatch(startFreshRun());
    navigate(APP_ROUTE.SAT_ACT_BOOSTER);
    close();
  };

  return (
    <>
      <Button
        id="booster-replan-btn"
        variant="contained"
        size="sm"
        hierarchy="Primary"
        startIcon={<AppIcon iconName="RefreshCcw01" diameter="16px" color="currentColor" />}
        onClick={() => setConfirmOpen(true)}
      >
        {STRINGS.cta}
      </Button>

      <ConfirmModal
        open={confirmOpen}
        onClose={close}
        variant="destructive"
        headerText={STRINGS.confirmTitle}
        bodyText={STRINGS.confirmBody}
        primaryAction={{
          id: 'booster-retake-confirm-btn',
          label: STRINGS.confirmCta,
          onClick: handleRetake,
        }}
        secondaryAction={{
          id: 'booster-retake-cancel-btn',
          label: STRINGS.cancel,
          onClick: close,
        }}
      />
    </>
  );
};
